import { render, staticRenderFns } from "./selectProperty.vue?vue&type=template&id=663f2a65"
import script from "./selectProperty.ts?vue&type=script&lang=js&external"
export * from "./selectProperty.ts?vue&type=script&lang=js&external"
import style0 from "./selectProperty.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports